module.exports = __webpack_public_path__ + "static/img/brush.4476803.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/brush.png
// module id = EX6V
// module chunks = 1